export default "__VITE_ASSET__040fd6da__"